import React, { useMemo } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import PathwaySwitchInputGroup from "../_UI/Components/Inputs/PathwaySwitchInputGroup";
import { PathwayFormGrid } from "../_UI/StyledComponents/PathwayForm";
import { LoadingSpinnerButton, PathwayButton } from "../_UI/Components/PathwayButtons";
import { FlexibleButtonModalFooter } from "../_UI/StyledComponents/PathwayModal";
import { ErrorMessage } from "../_UI/Components/Alerts/PathwayAlertMessages";
import stringUtils from "../_services/string-utils";

const ConfirmDeletionModalWithText = ({
    show,
    loading,
    title,
    content,
    confirmButtonColor,
    confirmButtonText,
    toggle,
    confirmDeletion,
    errorMessage,
    buttonCyData,
    modalCyData,
    deleteConfigurationRequest,
    changeDeleteConfigurationRequest,
}) => {
    const titleId = useMemo(() => "confirm-modal-title-" + stringUtils.randomString(), []);
    const headerTitle = title ? title : "Wirklich löschen?";
    return (
        <Modal
            isOpen={show}
            toggle={loading ? undefined : () => toggle(null)}
            labelledBy={titleId}
        >
            <ModalHeader toggle={loading ? undefined : () => toggle(null)} data-cy={modalCyData}>
                <span id={titleId}>{headerTitle}</span>
            </ModalHeader>
            <ModalBody>
                <PathwayFormGrid>
                    {content && <div>{content}</div>}
                    {deleteConfigurationRequest && changeDeleteConfigurationRequest && (
                        <PathwaySwitchInputGroup
                            name={"deleteConnectedAuthData"}
                            value={deleteConfigurationRequest.deleteConnectedAuthData}
                            onChange={changeDeleteConfigurationRequest}
                            dataCy={"delete-connected-auth-data"}
                            label={"Die dazugehörige API-Verbindung ebenfalls löschen."}
                        />
                    )}
                </PathwayFormGrid>
                <ErrorMessage messages={errorMessage} useTopMargin useBottomMargin={false} />
            </ModalBody>
            <FlexibleButtonModalFooter>
                <LoadingSpinnerButton
                    color={confirmButtonColor ? confirmButtonColor : "danger"}
                    loading={loading}
                    onClick={confirmDeletion}
                    buttonCyData={buttonCyData}
                    disabled={loading}
                >
                    {confirmButtonText ? confirmButtonText : "Löschen"}
                </LoadingSpinnerButton>
                <PathwayButton color="secondary" disabled={loading} onClick={() => toggle(null)}>
                    Abbrechen
                </PathwayButton>
            </FlexibleButtonModalFooter>
        </Modal>
    );
};

ConfirmDeletionModalWithText.propTypes = {
    show: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    confirmButtonText: PropTypes.string,
    confirmButtonColor: PropTypes.string,
    toggle: PropTypes.func.isRequired,
    confirmDeletion: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    buttonCyData: PropTypes.string,
    modalCyData: PropTypes.string,
    deleteConfigurationRequest: PropTypes.object,
    changeDeleteConfigurationRequest: PropTypes.func,
};

export default ConfirmDeletionModalWithText;
